var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTarget = function SvgTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 9.333v-3.5l3.5-3.5 1.167 2.333 2.333 1.167-3.5 3.5zm0 0L14 14m11.666 0c0 6.443-5.223 11.666-11.666 11.666S2.333 20.443 2.333 14 7.556 2.333 14 2.333M19.833 14A5.833 5.833 0 1 1 14 8.166"
  })));
};
export default SvgTarget;